const loader = document.currentScript as HTMLScriptElement | null;
const loaderURL = new URL(loader?.src || window.location.href, document.baseURI);

function loadMathJax() {
  const current = window.MathJax;
  if (current && typeof current.typesetPromise === 'function') return;
  if (document.querySelector('script[data-slopshell-mathjax]')) return;
  const script = document.createElement('script');
  const source = new URL('./vendor/mathjax/tex-svg.js', loaderURL);
  const version = loaderURL.searchParams.get('v');
  if (version) source.searchParams.set('v', version);
  script.src = source.toString();
  script.async = true;
  script.dataset.slopshellMathjax = 'true';
  document.head.appendChild(script);
}

function scheduleMathJax() {
  window.setTimeout(() => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(loadMathJax, { timeout: 4_000 });
      return;
    }
    loadMathJax();
  }, 1_500);
}

if (document.readyState === 'complete') scheduleMathJax();
else window.addEventListener('load', scheduleMathJax, { once: true });
